import { CategoricalPalette, FoClass } from './types';

// ColorBrewer Set2-flavored qualitative palette tuned for the figma dark
// background. Hex values MUST stay byte-identical to the palette in
// scripts/generate-fo-data.py — the overlay PNG is what the map legend
// describes. If you change one, change both.
//
// Display order is largest private block first, then the public ladder
// (federal → state → local), tribal, then the gray "unknown forest" bucket last.
export const FO_PALETTE: CategoricalPalette<FoClass> = {
  colors: {
    family:         '#66C2A5',
    corporate:      '#FC8D62',
    tribal:         '#E78AC3',
    federal:        '#8DA0CB',
    state:          '#A6D854',
    local:          '#FFD92F',
    unknown_forest: '#B3B3B3',
  },
  labels: {
    unknown_forest: 'Unknown Forest',
    family:         'Family',
    corporate:      'Corporate / Other Private',
    tribal:         'Tribal',
    federal:        'Federal',
    state:          'State',
    local:          'Local',
  },
  order: [
    'family',
    'corporate',
    'federal',
    'state',
    'tribal',
    'local',
    'unknown_forest',
  ],
};

// Public / private groupings used for the headline summary line. "Tribal" is
// conventionally grouped with public lands in USFS reporting; the UI notes
// this explicitly rather than hiding the nuance.
export const FO_PRIVATE_CLASSES: FoClass[] = ['family', 'corporate'];
export const FO_PUBLIC_CLASSES:  FoClass[] = ['federal', 'state', 'local', 'tribal'];
